    import fileModel from '@/shared/file/file-model';

export default {
  default() {
    return {
      id: null,
      pictures: [],
      teams: [],
      logo: {
        name:"",
        size:0,
        url:""
      }
    }
  },

  forSimple(data) {
    return {
      id: data.id,
      logo: data.logo ? fileModel.toDatabaseFile(data.logo) : {
        name:"",
        size:0,
        url:""
      },
      name: data.name  ? data.name : '',
      manager: data.manager ? data.manager : null
    }
  },

  forManager(data) {
    return {
      id: data.id,
      name: data.name,
      logo: fileModel.toDatabaseFile(data.logo),

      // manager: data.manager ? data.manager : null,
       teams: data.teams
    }
  },

  forCreate(data) {
    return {
      ...data,
      // pictures: fileModel.toDatabase(data.pictures),
      logo: fileModel.toDatabaseFile(data.logo)
    };
  },

  forUpdate(data) {
    return {
      ...data,
      // pictures: fileModel.toDatabase(data.pictures),
      logo: fileModel.toDatabaseFile(data.logo)
    };
  }
};



// WEBPACK FOOTER //
// ./src/entities/club/club-model.js